<template>
  <div v-wechat-title="$route.meta.title">
    <common-header @setLocale="getLocale"></common-header>
    <common-nav :locale="locale"></common-nav>
    <common-banner :locale="locale" title="zzrz"></common-banner>
    <common-title :cn="$t('txt.zzrz')" style="margin-top: 50px;"></common-title>
    <div class="certificates">
      <div
        v-for="(event, index) in items"
        :key="index"
        class="certificates-item"
      >
        <img :src="event.image" class="certificates-item-img" />
        <div class="certificates-item-title">{{ event.title }}</div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonBanner from "./components/Common/Banner";
import CommonTitle from "./components/Common/Title";
import zzrz02 from "../assets/images/zzrz02.jpg";
import zzrz03 from "../assets/images/zzrz03.jpg";
import zzrz04 from "../assets/images/zzrz04.jpg";
import zzrz05 from "../assets/images/zzrz05.jpg";
import zzrz06 from "../assets/images/zzrz06.jpg";
import zzrz07 from "../assets/images/zzrz07.jpg";

export default {
  components: {
    UAnimateContainer,
    UAnimate,
    CommonNav,
    CommonHeader,
    CommonFooter,
    CommonTitle,
    CommonBanner
  },
  data() {
    return {
      detail: "",
      id: "",
      items: [],
      locale: "zh-cn"
    };
  },
  created() {
    let _router = this.$route;
    this.id = _router.params.id;
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
  },
  watch: {
    locale(a, b) {
      this.locale === "en-us"
        ? (this.items = [
            {
              title: "Innovative Enterprises",
              url: zzrz03
            },
            {
              title: "Foshan Specialized, Refined, Special and New Enterprise",
              url: zzrz04
            },
            {
              title: "High-tech enterprise",
              url: zzrz05
            },
            {
              title: "ISO9001 certification",
              url: zzrz06
            },

            {
              title: "IATF16949 certification",
              url: zzrz07
            }
          ])
        : [
            {
              title: "创新型企业",
              url: zzrz03
            },
            {
              title: "佛山市专精特新企业",
              url: zzrz04
            },
            {
              title: "高新技术企业",
              url: zzrz05
            },
            {
              title: "ISO9001认证",
              url: zzrz06
            },

            {
              title: "IATF16949 认证",
              url: zzrz07
            }
          ];
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let lang2 = this.locale ? this.locale : "zh-cn";
      this.$axios
        .post(
          "/api/about/certification",
          {
            id: this.id
          },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.errorCode === 0) {
            this.items = res.data.data;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.certificates {
  width: 80%;
  margin: 0 auto;
  position: relative;
  margin-top: 1rem;
  display: flex;
  margin-bottom: 1rem;
  padding: 0.2rem 0;
  flex-wrap: wrap;
  &-item {
    width: 30%;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &-img {
      margin-bottom: 0.2rem;
    }
    &-title {
      font-size: 20px;
      text-align: center;
    }
  }
}

@media screen and (max-width: 750px) {
  .certificates {
    width: 100%;
    flex-direction: column;
    &-item {
      width: 100%;
      margin-bottom: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ZZRZ.vue